import "./invoice-status-badge.css";

import { Button } from "@tql/ui-components-react/tql/buttons";
import { useNavigate } from "react-router";

import { getInvoiceStatusDisplayDetails } from "~/features/quote-board/utils/invoice-status-display.ts";
import type { Invoice } from "~/shared/schemas/invoice-schema";

type InvoiceStatusBadgeProps = {
	invoice: Invoice;
};

export const InvoiceStatusBadge = ({ invoice }: InvoiceStatusBadgeProps) => {
	const navigate = useNavigate();

	const { className, text, url } = getInvoiceStatusDisplayDetails(invoice);

	const handleClick = () => {
		if (url) navigate(url);
	};

	return (
		<div className={`${className} invoice-status-wrapper`}>
			<Button
				data-testid={"invoice-status-badge"}
				disabled={!url}
				onClick={handleClick}
			>
				{text}
			</Button>
		</div>
	);
};
